import { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'

export const links = [
  { to: '/',          label: 'Inicio' },
  { to: '/servicios', label: 'Servicios' },
  { to: '/nosotros',  label: 'Quiénes somos' },
  { to: '/contacto',  label: 'Contacto' },
  { to: '/tienda',    label: 'Tienda' },
]

interface NavbarProps {
  onClose?: () => void
}

export default function Navbar({ onClose }: NavbarProps) {
  const [isMobileMenuOpen, setIsOpen] = useState(false)

  const closeMenu = () => {
    setIsOpen(false)
    if (onClose) onClose()
  }

  const toggleMenu = () => setIsOpen(!isMobileMenuOpen)

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-100 z-50 shadow-sm h-20">
      <div className="container mx-auto px-4 lg:px-8 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" onClick={closeMenu} className="flex-shrink-0">
          <img
            src="/logo.png" 
            alt="Construredgas SAS" 
            className="h-16 w-auto transition-transform duration-300 hover:scale-110"
          />
        </Link>

        {/* Navegación Desktop */}
        <nav className="hidden lg:flex items-center space-x-1">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg text-sm font-bold tracking-wide transition-all duration-300
                 ${isActive 
                   ? 'text-orange-100 bg-orange-600 shadow-md shadow-orange-500/30' 
                   : 'text-gray-600 hover:text-orange-600 hover:bg-orange-50'}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/* Botón Mobile */}
        <button 
          onClick={toggleMenu}
          className="lg:hidden p-2 text-crg-dark hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Abrir menú"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen 
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>
      </div>

      {/* Menú Mobile Desplegable */}
      <div className={`
        absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-xl lg:hidden
        transition-all duration-300 ease-in-out transform origin-top
        ${isMobileMenuOpen ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0 pointer-events-none'}
      `}>
        <nav className="flex flex-col p-4 space-y-2 bg-white">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              onClick={closeMenu}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg text-base font-bold transition-all
                 ${isActive 
                   ? 'text-orange-100 bg-orange-600 shadow-lg shadow-orange-500/20' 
                   : 'text-gray-700 hover:text-orange-600 hover:bg-orange-50'}`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <div className="pt-4 mt-2 border-t border-gray-100 text-center">
            <p className="text-[10px] text-gray-400 uppercase tracking-widest">NIT: 900.510.731-9</p>
          </div>
        </nav>
      </div>
    </header>
  )
}